<template>
  <section class="follow-section" :class="{ boxclose: boxShow }">
    <!-- <nav class="follow-nav">
      <HeaderSection></HeaderSection>
      <img src="@/assets/img/logo.png" alt="logo" style="width:90px;height:95%">
      <p style="font-weight:bold">ویترین نوین اینترنتی</p>
      
      <button disabled class="follow-btn" style="background-color: #c5ac7f">
        دنبال کردن
      </button>
      <FollowersSummary></FollowersSummary>
    </nav> -->
    <nav class="follow-nav2">
      <HeaderSection :small="true"></HeaderSection>
      <div class="switch-box">
        <img
          src="@/assets/img/logo.png"
          alt="logo"
          style="width: 90px; height: 95%"
        />
        <p style="font-weight: bold">ویترین نوین اینترنتی</p>
        <!-- <button disabled class="follow-btn" style="background-color: #c5ac7f">
        دنبال کردن
      </button>
      <FollowersSummary></FollowersSummary> -->
      </div>
    </nav>
    <div class="qr-code-box-shadow">
      <div class="shadow"></div>
      <div class="qr-code-box">
        <p>دوربین گوشی را روی بارکد قرار دهید</p>
        <div class="img-div">
          <div class="theme-upper-image"></div>
          <div class="theme-upper-image2"></div>
          <div class="right-div"></div>
          <div
            class="qr-code-div"
            @click="qrcodeZoomActive = !qrcodeZoomActive"
          >
            <img
              :src="'https://witrino.com/qr-code/' + token + '.png'"
              alt="qr-code"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="qr-code-box-btn" @click="qrcodeBoxShow"></div>
  </section>
  <transition name="zoom">
    <div
      v-if="qrcodeZoomActive"
      class="qrcode-zoom"
      @click="qrcodeZoomActive = !qrcodeZoomActive"
    >
      <img :src="'https://witrino.com/qr-code/' + token + '.png'" alt="" />
      <p>{{ token }}</p>
      <p>تصویر فوق را اسکن کنید</p>
    </div>
  </transition>
</template>

<script>
// import FollowersSummary from "@/components/FollowersSummary/index.vue";
import HeaderSection from "@/components/header/index.vue";
import { sellerData } from "@/repo/sellerData.js";
import { mapGetters } from "vuex";

export default {
  name: "FollowSummary",
  data() {
    return {
      qrcodeZoomActive: false,
      boxShow: false,
      token: null,
    };
  },
  components: {
    HeaderSection,
  },
  mixins: [sellerData],
  methods: {
    qrcodeBoxShow() {
      this.boxShow = !this.boxShow;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.token =
      this.themeInfo?.info?.business.token || this.$route.params.token;
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/follow/follow.css);
</style>